export default {
  heading: 'Montserrat',
  body: 'Open Sans',
};
